var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { LoadingPane } from "@folio/stripes/components";
import { useQuery } from "react-query";
import CollectionForm from "./CollectionForm";
import { navigation } from "../../components/navigation";
import { fetchCollectionById, updateCollection, } from "../../api/collectionsService";
var CollectionsEdit = function () {
    var _a;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useQuery(["collection", id], function () { return fetchCollectionById(ky, id); }, {
        staleTime: Infinity,
    }), collection = _b.data, error = _b.error, isLoading = _b.isLoading, isError = _b.isError;
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    payload = __assign(__assign({}, data), { id: (_b = (_a = data.id) !== null && _a !== void 0 ? _a : collection === null || collection === void 0 ? void 0 : collection.id) !== null && _b !== void 0 ? _b : id, version: (_c = data.version) !== null && _c !== void 0 ? _c : collection === null || collection === void 0 ? void 0 : collection.version });
                    return [4 /*yield*/, updateCollection(ky, id, payload)];
                case 1:
                    _d.sent();
                    if (navigation.collections) {
                        history.push(navigation.collections.path);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    console.error("Error updating collection:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    if (isLoading)
        return React.createElement(LoadingPane, null);
    if (isError || !collection) {
        return React.createElement("div", null,
            "Error: ", (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "collection not found");
    }
    return (React.createElement(CollectionForm, { initialValues: collection, onSubmit: handleSubmit, title: formatMessage({ id: "ui-br-agency.collections.edit.pane.title" }), onCancel: function () {
            return navigation.collections && history.push(navigation.collections.path);
        } }));
};
export default CollectionsEdit;
